module.exports = __webpack_public_path__ + "img/pexels-photo-127873.f0874a5b.png";